import {defineStore} from "pinia"

export const useTabbarStore = defineStore("tabbar", {
    state: () => ({
        tabbar:[],
        color: {
            headColor: "#ffffff",
            tabColor: "#ffffff",
            contentColor: "#f0f4f8",
            color: "#334155"
        },
        tabs: [],
        activeTab: '',
        // 被缓存的组件 name 列表（与 tabs 的 path 一一对应，用于 keep-alive include）
        cachedNames: []
    }),
    actions: {
        setTabbar(tabbar){
            this.tabbar.splice(0, this.tabbar.length, ...tabbar)
        },
        setColor(color){
            Object.assign(this.color, color)
        },
        addTab(tab) {
            const exists = this.tabs.find(t => t.path === tab.path)
            if (!exists) {
                this.tabs.push(tab)
            }
            this.activeTab = tab.path
            // 同步加入缓存
            this.addCachedName(tab.path)
        },
        removeTab(path) {
            const index = this.tabs.findIndex(t => t.path === path)
            if (index > -1) {
                this.tabs.splice(index, 1)
                if (this.activeTab === path && this.tabs.length > 0) {
                    this.activeTab = this.tabs[Math.max(index - 1, 0)].path
                } else if (this.tabs.length === 0) {
                    this.activeTab = ''
                }
            }
            // 同步移除缓存
            this.removeCachedName(path)
        },
        setActiveTab(path) {
            this.activeTab = path
        },
        clearTabs() {
            this.tabs = []
            this.activeTab = ''
            this.cachedNames = []
        },
        // 新增缓存 name
        addCachedName(name) {
            if (name && !this.cachedNames.includes(name)) {
                this.cachedNames.push(name)
            }
        },
        // 移除缓存 name
        removeCachedName(name) {
            const index = this.cachedNames.indexOf(name)
            if (index > -1) {
                this.cachedNames.splice(index, 1)
            }
        },
        // 关闭其他标签页
        removeOtherTabs(path) {
            this.tabs = this.tabs.filter(t => t.path === path)
            this.cachedNames = this.tabs.map(t => t.path)
            this.activeTab = path
        },
        // 关闭所有标签页并跳转到指定页
        removeAllTabs(keepPath) {
            if (keepPath) {
                const keepTab = this.tabs.find(t => t.path === keepPath)
                this.tabs = keepTab ? [keepTab] : []
                this.cachedNames = keepTab ? [keepPath] : []
                this.activeTab = keepPath
            } else {
                this.tabs = []
                this.cachedNames = []
                this.activeTab = ''
            }
        }
    },
    getters: {
        getTabbar: (state) => state.tabbar,
        getColor: (state) => state.color,
        getTabs: (state) => state.tabs,
        getActiveTab: (state) => state.activeTab,
        // 直接返回 state.cachedNames，保持响应性（Pinia getter 内部已自动处理响应）
        getCachedNames: (state) => state.cachedNames
    }
})
